var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:#f8edeb;}"), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: 6.65,
    x2: 27.27,
    y1: 6.65,
    y2: 27.27
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef6461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e83d3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 6,
    x2: 12,
    xlinkHref: "#linear-gradient",
    y1: 5,
    y2: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.5,2h-12a.47.47,0,0,0-.35.15l-5,5A.47.47,0,0,0,6,7.5v20A2.5,2.5,0,0,0,8.5,30h15A2.5,2.5,0,0,0,26,27.5V4.5A2.5,2.5,0,0,0,23.5,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.69,2a.47.47,0,0,0-.54.11l-5,5A.47.47,0,0,0,6,7.69.5.5,0,0,0,6.5,8h3A2.5,2.5,0,0,0,12,5.5v-3A.5.5,0,0,0,11.69,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.5,11h-1a.5.5,0,0,0-.5.5v9a.5.5,0,0,0,.5.5h1A2.5,2.5,0,0,0,18,18.5v-5A2.5,2.5,0,0,0,15.5,11ZM17,18.5A1.5,1.5,0,0,1,15.5,20H15V12h.5A1.5,1.5,0,0,1,17,13.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.5,11h-2a.5.5,0,0,0-.5.5v9a.5.5,0,0,0,1,0V17h1.5A1.5,1.5,0,0,0,13,15.5v-3A1.5,1.5,0,0,0,11.5,11Zm.5,4.5a.5.5,0,0,1-.5.5H10V12h1.5a.5.5,0,0,1,.5.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.5,15H20V12h2.5a.5.5,0,0,0,0-1h-3a.5.5,0,0,0-.5.5v9a.5.5,0,0,0,1,0V16h2.5a.5.5,0,0,0,0-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPdf);
export default __webpack_public_path__ + "static/media/ic-pdf.a7087676fedf16f40557862d0f1e0bd1.svg";
export { ForwardRef as ReactComponent };